import CliBillingIndex from "@/components/billing/cli/CliBillingIndex.vue";
import CliBillingDetail from "@/components/billing/cli/CliBillingDetail.vue";
import CliBillingEdit from "@/components/billing/cli/CliBillingEdit.vue";
import CliBillingSubDetail from "@/components/billing/cli/CliBillingSubDetail.vue";

let routesCliBillingAccess= [
    {
        path: '',
        meta: {
          title: "List CLI Billing",
        },
        name: "CliBillingIndex",
        component: CliBillingIndex
    },     
    {
        path: 'detail/:id',
        meta: {
          title: "Detail CLI Billing",
        },
        name: "CliBillingDetail",
        component: CliBillingDetail
    },     
    {
        path: 'edit/:id',
        meta: {
          title: "Edit CLI Billing",
        },
        name: "CliBillingEdit",
        component: CliBillingEdit
    },  
    {
        path: 'sub-detail/:idBillingHeader/:idBillingDetail/:chargeCategory/:chargeType',
        meta: {
          title: "Sub Detail CLI Billing",
        },
        name: "CliBillingSubDetail",
        component: CliBillingSubDetail
    },
    
]

export default routesCliBillingAccess
  